module.exports = __webpack_public_path__ + "img/Logo_DigiBos_White.1831880f.png";